import React from 'react'
import PropTypes from 'prop-types'
import Pagination from './Pagination'

class PaginationContainer extends React.PureComponent {
  constructor (props, context) {
    super(props, context)
    this.updatePagination(props, {initState: true})
  }

  updatePagination = (props, options = {}) => {
    const totalPages = Math.ceil(props.total / props.limit)
    let currentPage = props.currentPage
    if (!('currentPage' in props)) {
      let pageParam = 0
      if (this.props.updateRoute) {
        pageParam = this.props.match && this.props.match.params && this.props.match.params.paginationPage
      } else {
        pageParam = currentPage || 1
      }
      currentPage = pageParam ? parseInt(pageParam) : 1
    }

    const min = Math.max(1, currentPage - 3)
    const max = Math.min(currentPage + 3, totalPages - 1)
    const pages = min === 1 ? [1] : ['First']
    for (var i = min; i < max; i++) {
      pages[i] = i + 1
    }
    pages[totalPages - 1] = max === totalPages - 1 ? totalPages : 'Last'

    const state = {
      currentPage,
      limit: props.limit,
      total: props.total,
      pages: pages
    }

    if (options.initState) {
      this.state = state
    } else {
      this.setState(state)
    }
  }

  componentWillReceiveProps (props) {
    this.updatePagination(props)
  }

  onPrevPage = () => {
    const page = this.state.currentPage

    if (page && page > 1) {
      this.onChangePage(page - 1)
    }
  }

  onNextPage = () => {
    const page = this.state.currentPage
    const totalPages = Math.ceil(this.state.total / this.props.limit)

    if (page && page < totalPages) {
      this.onChangePage(page + 1)
    }
  }

  onChangePage = (currentPage) => {
    if (this.props.history) {
      const path = this.props.match.path
      const previousClassName = document.body.className
      if (this.props.updateRoute) {
        this.props.history.push(path.replace(':paginationPage', currentPage))
      }
      // reset 'modal-open' class
      // this is a fix to a bootstrap/reactstrap issue.
      setTimeout(() => {
        if (previousClassName && previousClassName.indexOf('modal-open') !== -1) {
          if (!document.body.className || document.body.className === '') {
            document.body.className = 'modal-open'
          } else {
            document.body.className += ' modal-open'
          }
        }
      })
    }

    if (typeof (this.props.onChangePage) === 'function') {
      this.setState({currentPage})
      this.props.onChangePage(currentPage)
    }
  }

  render () {
    if (!this.state.total) { return null }
    return <Pagination
      currentPage={this.state.currentPage}
      total={this.state.total}
      pages={this.state.pages}
      changePage={this.onChangePage}
      prevPage={this.onPrevPage}
      nextPage={this.onNextPage} />
  }
}

PaginationContainer.propTypes = {
  currentPage: PropTypes.number, // eslint-disable-line
  limit: PropTypes.number,
  match: PropTypes.object,
  history: PropTypes.object,
  updateRoute: PropTypes.bool,
  onChangePage: PropTypes.func
}

PaginationContainer.defaultProps = {
  updateRoute: true
}

export default PaginationContainer



// WEBPACK FOOTER //
// ./src/components/Pagination/PaginationContainer.js